/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/month_name.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Returns the month name for the provided date based on the configured Locale.
 *
 * @example
 * ROW dt = to_datetime("1996-03-21T00:00:00.000Z")
 * | EVAL monthName = MONTH_NAME(dt);
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'month_name',
  signatures: [
    {
      params: [
        {
          name: 'date',
          type: 'date',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'date',
          type: 'date_nanos',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
